module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10078.eba35ebb.jpg";